import React from 'react';

import { V1CloudEventsInsightCategory } from '@ariksa/audittrail/api';
import { CloudProviders } from '@ariksa/cloud-account/api';
import { ComplianceStandards } from '@ariksa/compliance-policies';
import { CloudEnvironmentType } from '@ariksa/compliance-policies/api';
import { SupportedServices } from '@ariksa/data-scanning/api';
import { ContextType } from '@ariksa/inventory-core';
import {
  Categories,
  CloudProvider,
  NativeResources,
  Resources,
} from '@ariksa/inventory-core/api';
import { Clients } from '@ariksa/notification';
import { ReportTypes } from '@ariksa/reporting';
import { Image } from '@chakra-ui/react';
import { includes, lowerCase } from 'lodash';
import { BsQuestionCircle } from 'react-icons/all';
import {
  ApplicationEnum,
  LibraryType,
  ScanTypes,
  VulnerabilityType,
} from 'services/Vulnerability/types';

import { IdentityProviderName } from 'api/auth/api.pb';
import {
  AccessIcon,
  AccountIcon,
  ActionLogsIcon,
  ActivityIcon,
  AMIIcon,
  AnalyticsIcon,
  ApacheCassandraIcon,
  ApacheHttpIcon,
  ApacheKafkaIcon,
  APIGatewayApiIcon,
  APIGatewayIcon,
  AppIcon,
  ApplicationOrchestrationElasticBeanstalkIcon,
  AutoScalingIcon,
  AwsIcon,
  AzureADDomainIcon,
  AzureADRoleIcon,
  AzureIcon,
  BackupIcon,
  BellIcon,
  BlockStorageIcon,
  CacheBehaviourIcon,
  CertificateIcon,
  ChecklistIcon,
  CheckmarkCircleOutlineIcon,
  ClockIcon,
  CloudFormationIcon,
  CloudServiceIcon,
  CloudtrailIcon,
  ClusterIcon,
  ConfigurationIcon,
  ConsoleIcon,
  ContextIcon,
  CouchDBIcon,
  DatabaseIcon,
  DataScanIcon,
  DistributionCloudfrontIcon,
  DistributionIcon,
  DNSIcon,
  DocumentDBIcon,
  ECSInstanceIcon,
  EcsTaskIcon,
  EgressIcon,
  ElasticacheIcon,
  EcsClusterIcon,
  ElasticIPIcon,
  ElasticMapReduceIcon,
  ElasticsearchIcon,
  EnvironmentIcon,
  EventLogIcon,
  ExceptionIcon,
  ExclamationTriangleIcon,
  FileIcon,
  GoogleCloudIcon,
  GroupIcon,
  IngressIcon,
  InterfaceIcon,
  InternetGatewayIcon,
  JiraIcon,
  KeyIcon,
  KubernetesIcon,
  AmazonLinuxIcon,
  LoadBalancerIcon,
  MachineLearningIcon,
  MariaDBIcon,
  MemCachedIcon,
  MetadataIcon,
  MoneyDataIcon,
  MongoDBIcon,
  MonitoringIcon,
  MysqlIcon,
  NatGatewayIcon,
  Neo4jIcon,
  NeptuneClusterIcon,
  NeptuneInstanceIcon,
  NetworkACLIcon,
  NetworkInterfaceIcon,
  NginxIcon,
  NoSqlIcon,
  NotificationIcon,
  ObjectStorageIcon,
  OktaIcon,
  OperatingSystemIcon,
  OrganizationIcon,
  OrganizationUnitIcon,
  P2PIcon,
  PackagesIcon,
  PayIcon,
  PermissionsActionsIcon,
  PolicyIcon,
  PostgreSQLIcon,
  PythonIcon,
  QueueIcon,
  RabbitMQIcon,
  RdsClusterIcon,
  RdsInstanceIcon,
  RedisIcon,
  RegionIcon,
  RoleIcon,
  Route53HealthCheckIcon,
  Route53HostedZoneIcon,
  RouteIcon,
  RouteTableIcon,
  SagemakerMachineLearningIcon,
  SecretsPasswordIcon,
  SecurityGroupIcon,
  ServerlessIcon,
  ServicesIcon,
  SlackIcon,
  SnapshotIcon,
  SnsNotificationIcon,
  SSHKeyPairIcon,
  SubnetIcon,
  SuperNetIcon,
  SuppressAlarmIcon,
  TechnologyIcon,
  TransitGatewayAttachmentIcon,
  TrustedEntitiesIcon,
  UbuntuIcon,
  UserIcon,
  VirtualMachineIcon,
  VmwareIcon,
  VpcGatewayIcon,
  VulnerabilityIcon,
  WAFIcon,
  RedshiftIcon,
  BarChartIcon,
  ServiceNowIcon,
  MailIcon,
  MicrosoftTeamsIcon,
  SMSIcon,
  TicketIcon,
  SSOIcon,
  AzureActiveDirectoryIcon,
  SnowflakeIcon,
  SearchIcon,
  RemediateIcon,
  ShowIcon,
  TimelineIcon,
  DisableIcon,
  ContainerVolumeIcon,
  DataClassificationIcon,
  DhcpOptionsIcon,
  BlueprintExceptionIcon,
  CommandLineIcon,
  NISTIcon,
  PciIcon,
  CISIcon,
  Soc2Icon,
  CompanyLogoIcon,
  CloudChartIcon,
  RegexDataClassifierIcon,
  ComplianceResourceIcon,
  ComplianceEnforcedChecksIcon,
  ComplianceCheckExceptionIcon,
  ComplianceCheckFailedIcon,
  ComplianceCheckPassedIcon,
  HistoricalTimelineIcon,
  HomeIcon,
  AccountRootIcon,
  ListIcon,
  AutomationIcon,
  OverviewIcon,
  SummaryIcon,
  NetworkMapIcon,
  UserCanAccessIcon,
  InternetAccessIcon,
  BruteForceIcon,
  LineChartIcon,
  BurgerMenuIcon,
  HAProxyIcon,
  UnencryptedDiskIcon,
  AccessKeyIcon,
  SSMDocumentIcon,
  Ec2AutoScalingGroupIcon,
  CloudWatchMonitoringIcon,
  RdsCertificateIcon,
  ApiIcon,
  PolicyResourceIcon,
  PolicyAccountIcon,
  PolicyOrganizationIcon,
  PolicyRoleIcon,
  DocumentDbClusterIcon,
  DynamoDbIcon,
  Ec2LaunchTemplateIcon,
  EcrImageIcon,
  EcsServiceIcon,
  ElastiCacheReplicationGroupIcon,
  AgentIcon,
  IamPolicyIcon,
  VpcFlowLogIcon,
  VpnGatewayIcon,
  TableIcon,
  DataCloudIcon,
  IdentityCloudIcon,
  SnoozeIcon,
  RubyIcon,
  GolangIcon,
  JavaIcon,
  NodeJSIcon,
  CrossAccountIcon,
  MaliciousIngressIcon,
  VpnIcon,
  RdsIcon,
  CriticalDataIcon,
  HighPrivilegesIcon,
  SIEMIcon,
  RulesIcon,
  AttachIcon,
  DetachIcon,
  GitLabIcon,
  GithubIcon,
  BitbucketIcon,
  InventoryIcon,
  RepoBranchIcon,
  CopyIcon,
  CloudIcon,
  PolicyExceptionResourceIcon,
  PolicyExceptionIcon,
  DashboardAllIcon,
  LockOpenIcon,
  GlobeIcon,
  NetworkMisconfigurationIcon,
  ThumbsDownIcon,
  SyncPauseIcon,
  OutpostForVulnerabilityIcon,
  CommentIcon,
  ZigzagIcon,
  ThirdPartyIcon,
  NewFindingIcon,
  AnomalousBehaviourIcon,
  HealthIcon,
  GraphIncreaseIcon,
  GraphDecreaseIcon,
  CloseCircleOutlineIcon,
  ActionsIcon,
  BlueprintViewIcon,
  CalendarIcon,
  ChatIcon,
  CloudSlashIcon,
  DashboardIcon,
  DatabaseSecurityIcon,
  DependenciesIcon,
  DoubleTapIcon,
  ExcludeIcon,
  DebianIcon,
  NpmIcon,
  RpmIcon,
  VMImageIcon,
  ShareIcon,
  ThirdPartyIntegrationIcon,
  SqlDatabaseIcon,
  ListOfInstancesIcon,
  SuppressIcon,
  EOLIcon,
  RedHatIcon,
  CentosIcon,
  ContainerRepositoryIcon,
  LearnMoreIcon,
  GoogleDriveIcon,
  MicrosoftOneDriveIcon,
  BoxIcon,
  DropboxIcon,
  ServiceTicketIcon,
  DocumentsIcon,
  LibraryIcon,
  LeakedCredentialIcon,
  GoogleIcon,
  AlpineLinuxIcon,
  WorkflowIcon,
  ThreeDotsIcon,
  ChartMixedIcon,
  IssuesIcon,
  BusinessCriticalIcon,
  CSVIcon,
  ExportToSIEMIcon,
  AddOrCreateIcon,
  SecurityIcon,
  CveIcon,
  WindowsIcon,
  ISOIcon,
  NoneIcon,
  ActionIcon,
  LinkIcon,
  HighRiskIcon,
  AverageRiskIcon,
  OriginConfigurationsIcon,
  CacheIcon,
  SeverityIcon,
  AtIcon,
  JITIcon,
  CloudLakeFormationIcon,
  ContainerOrVMImageIcon,
  ThumbsUpIcon,
  NetworkPortIcon,
  PrinterIcon,
  DashboardOverviewIcon,
  DashboardCategoryIcon,
  ServerIcon,
  MachineImageIcon,
  RefreshIcon,
  ComplianceIcon,
  ScanningQueueIcon,
  PatchIcon,
  ArrowUpIcon,
  ArrowDownIcon,
  MinusIcon,
  AzureEntraIDIcon,
  AzureEntraConnectIcon,
  PlayIcon,
  PauseIcon,
  GCPModelArmorTemplateIcon,
  GCPModelArmorIcon,
  AIEndpointIcon,
  AIDatasetIcon,
  AISearchIcon,
  AIDeploymentIcon,
  AIModelIcon,
  AIIndexIcon,
  AIPipelineIcon,
  AIServiceIcon,
  AIDocumentProcessorIcon,
  AlertRuleIcon,
  ApiEndpointIcon,
  BastionHostIcon,
  BotIcon,
  CloudIdentityIcon,
  CloudMysqlIcon,
  CxAgentIcon,
  FirewallAclRulesIcon,
  IpAddressIcon,
  ServiceAccountIcon,
  EntraIdDomainIcon,
  WAFRulesIcon,
  AgentBuilderIcon,
  EntraIdServicePrincipalIcon,
  PolicyUserIcon,
  PolicyPasswordIcon,
  AWSQIcon,
  ForwardingRuleIcon,
  ComputeFleetIcon,
  CassandraIcon,
  AzureCosmosDbIcon,
  AzureDataExplorerIcon,
  RoleDefinitionIcon,
  AzureResourceGroupIcon,
  SuddenActivityIcon,
  DataGroupIcon,
  PolicyScrollIcon,
  NotifyIcon,
  HideIcon,
  MaskIcon,
  ExitFullscreenIcon,
  FullscreenIcon,
  ExclamationCircleIcon,
  InfinityIcon,
  LabelIcon,
  CreditCardIcon,
} from 'components/Icons';
import { AriksaLogoOnlyIcon } from 'components/Icons/ReactCustomIcons/AriksaLogoOnlyIcon';
import { BucketDenyIcon } from 'components/Icons/ReactCustomIcons/BucketDenyIcon';
import { ContextLabelIcon } from 'components/Icons/ReactCustomIcons/ContextLabelIcon';
import { DownloadIcon } from 'components/Icons/ReactCustomIcons/DownloadIcon';
import { EvidenceIcon } from 'components/Icons/ReactCustomIcons/EvidenceIcon';
import { HackerIcon } from 'components/Icons/ReactCustomIcons/HackerIcon';
import { IndividualAlertsIcon } from 'components/Icons/ReactCustomIcons/IndividualAlertsIcon';
import { LateralMovementIcon } from 'components/Icons/ReactCustomIcons/LateralMovementIcon';
import { LoginIcon } from 'components/Icons/ReactCustomIcons/LoginIcon';
import { PrefixListIcon } from 'components/Icons/ReactCustomIcons/PrefixListIcon';
import { PrincipalAccessIcon } from 'components/Icons/ReactCustomIcons/PrincipalAccessIcon';
import { SyncRestartIcon } from 'components/Icons/ReactCustomIcons/SyncRestartIcon';
import { TagIcon } from 'components/Icons/ReactCustomIcons/TagIcon';
import { TrustedEntityIcon } from 'components/Icons/ReactCustomIcons/TrustedEntityIcon';
import { ViewAllIcon } from 'components/Icons/ReactCustomIcons/ViewAllIcon';
import { ZoomInIcon } from 'components/Icons/ReactCustomIcons/ZoomInIcon';
import { ZoomOutIcon } from 'components/Icons/ReactCustomIcons/ZoomOutIcon';
import { ExploitableIcon } from 'components/Icons/ReactResourceIcons/ExploitableIcon';
import { RemoveIcon } from 'components/Icons/ReactResourceIcons/RemoveIcon';
import { Route53RecordSetIcon } from 'components/Icons/ReactResourceIcons/Route53RecordSetIcon';
import { CustomIconTypes, IconType, IconTypes } from 'components/Icons/types';

import { customTheme } from '../../../../theme';
import {
  AzureDatabricksIcon,
  AzureDataFactoryIcon,
  AzureDevOpsProjectIcon,
  AzureEventHubsIcon,
  AzureMLWorkspaceIcon,
  AzureSynapseAnalyticsIcon,
  ManagedIdentityIcon,
  RepoProjectIcon,
  SagemakerIcon,
  VirtualWANIcon,
  ApacheTomcatIcon,
} from '../ReactResourceIcons';
import internet from '../SvgResourcesIcon/svg/internet.jpeg';

export const getIcon = (
  type: IconType,
  bgColor?: string,
  defaultIcon?: React.ReactNode,
) => {
  switch (type) {
    case IconTypes.At:
      return <AtIcon />;

    case IconTypes.ArrowUp:
      return <ArrowUpIcon />;

    case IconTypes.ArrowDown:
      return <ArrowDownIcon />;

    case IconTypes.Minus:
      return <MinusIcon />;

    case IconTypes.JIT:
      return <JITIcon />;

    case IconTypes.Exploitable:
      return <ExploitableIcon />;

    case IconTypes.Fullscreen:
      return <FullscreenIcon />;

    case IconTypes.ExitFullscreen:
      return <ExitFullscreenIcon />;

    case NativeResources.DhcpOptions:
    case Resources.Dhcp:
      return <DhcpOptionsIcon />;

    case CustomIconTypes.Remove:
      return <RemoveIcon />;

    case CustomIconTypes.CloudLakeFormation:
      return <CloudLakeFormationIcon />;

    case CustomIconTypes.CacheBehaviour:
      return <CacheBehaviourIcon />;

    case CustomIconTypes.OriginConfigurations:
      return <OriginConfigurationsIcon />;

    case CustomIconTypes.SensitiveRecords:
      return <LabelIcon />;

    case CustomIconTypes.SSLv3:
    case CustomIconTypes.TLSv1:
    case CustomIconTypes.HttpOnly:
    case CustomIconTypes.AllowAll:
      return <HighRiskIcon p={0.5} />;

    case CustomIconTypes.TLSv11:
    case CustomIconTypes.MatchViewer:
    case CustomIconTypes.RedirectToHttps:
      return <AverageRiskIcon />;

    case CustomIconTypes.TLSv12:
    case CustomIconTypes.HttpsOnly:
      return (
        <CheckmarkCircleOutlineIcon color={customTheme.colors.green['300']} />
      );

    case CustomIconTypes.AddOrCreate:
      return <AddOrCreateIcon />;

    case CustomIconTypes.CSV:
      return <CSVIcon />;

    case CustomIconTypes.None:
      return <NoneIcon />;

    case CustomIconTypes.Security:
      return <SecurityIcon />;

    case CustomIconTypes.ExportToSIEM:
      return <ExportToSIEMIcon />;

    case CustomIconTypes.ThreeDots:
      return <ThreeDotsIcon />;

    case CustomIconTypes.BusinessCritical:
      return <BusinessCriticalIcon />;

    case CustomIconTypes.Issues:
      return <IssuesIcon />;

    case CustomIconTypes.MixedChart:
      return <ChartMixedIcon />;

    case CustomIconTypes.CommandLine:
      return <CommandLineIcon />;

    case CustomIconTypes.BlueprintException:
      return <BlueprintExceptionIcon />;

    case CustomIconTypes.Evidence:
      return <EvidenceIcon />;

    case CustomIconTypes.Link:
      return <LinkIcon />;

    case CustomIconTypes.AllFindings:
    case CustomIconTypes.DashboardAll:
      return <DashboardAllIcon />;

    case CustomIconTypes.AIML:
      return <MachineLearningIcon />;

    case CustomIconTypes.Dashboard:
      return <DashboardIcon />;

    case CustomIconTypes.DashboardOverview:
      return <DashboardOverviewIcon />;

    case CustomIconTypes.DashboardCategory:
      return <DashboardCategoryIcon />;

    case CustomIconTypes.ZoomIn:
      return <ZoomInIcon />;

    case CustomIconTypes.ZoomOut:
      return <ZoomOutIcon />;

    case CustomIconTypes.Download:
      return <DownloadIcon />;

    case CustomIconTypes.LateralMovement:
      return <LateralMovementIcon />;

    case CustomIconTypes.Login:
      return <LoginIcon />;

    case CustomIconTypes.PrefixList:
      return <PrefixListIcon />;

    case CustomIconTypes.PrincipalAccess:
      return <PrincipalAccessIcon />;

    case CustomIconTypes.TrustedEntity:
      return <TrustedEntityIcon />;

    case CustomIconTypes.ViewAll:
      return <ViewAllIcon />;

    case CustomIconTypes.Pii:
      return <MoneyDataIcon />;

    case CustomIconTypes.Calendar:
      return <CalendarIcon />;

    case Resources.ContainerRegistry:
    case IconTypes.Registry:
    case NativeResources.AzureContainerRegistry:
    case NativeResources.AmazonMachineImage:
    case NativeResources.AzureComputeGalleryImageVersion:
    case NativeResources.GcpImage:
    case NativeResources.GcpInstanceTemplate:
    case NativeResources.AzureManagedImage:
    case NativeResources.AzureMarketplaceImage:
    case CustomIconTypes.Ami:
    case CustomIconTypes.Images:
      return <AMIIcon />;

    case Resources.Image:
    case NativeResources.ElasticContainerRegistry:
      return <ContainerOrVMImageIcon />;

    case IconTypes.EcrImage:
      return <EcrImageIcon />;

    case NativeResources.EcsService:
      return <EcsServiceIcon />;

    case NativeResources.GcpModelArmorTemplate:
      return <GCPModelArmorTemplateIcon />;

    case NativeResources.GcpModelArmorFloorSetting:
      return <GCPModelArmorIcon />;

    case NativeResources.EcsCluster:
    case Resources.ContainerCluster:
      return <EcsClusterIcon p={0.5} />;

    case NativeResources.VpcFlowLogs:
    case NativeResources.AzureNetworkWatcherFlowLog:
      return <VpcFlowLogIcon />;

    case NativeResources.AwsBedrockCustomModel:
    case NativeResources.AwsBedrockProvisionedModel:
    case NativeResources.AwsBedrockFoundationModel:
    case NativeResources.AwsBedrockImportedModel:
    case NativeResources.SagemakerEndpoints:
    case NativeResources.SagemakerNotebookInstances:
    case CustomIconTypes.Sagemaker:
    case Categories.Ai:
      return <SagemakerIcon />;

    case CustomIconTypes.ECSTask:
      return <EcsTaskIcon />;

    case CustomIconTypes.Workflow:
      return <WorkflowIcon />;

    case IconTypes.Table:
    case NativeResources.SnowflakeTables:
    case NativeResources.AzureStorageTable:
      return <TableIcon />;

    case NativeResources.AzureAiAgents:
    case IconTypes.Bot:
      return <BotIcon />;

    case NativeResources.AzureAiSearch:
      return <AISearchIcon />;

    case NativeResources.AzureAiServices:
      return <AIServiceIcon />;

    case NativeResources.AzureApiCollection:
    case NativeResources.AzurePrivateEndpoint:
      return <ApiEndpointIcon />;

    case NativeResources.AzureActivityLogAlertRule:
    case NativeResources.AzureLogAlertRule:
      return <AlertRuleIcon />;

    case NativeResources.AzureMlWorkspace:
      return <AzureMLWorkspaceIcon />;

    case NativeResources.AzureManagedIdentity:
      return <ManagedIdentityIcon />;

    case NativeResources.AzureResourceGroup:
      return <AzureResourceGroupIcon />;

    case NativeResources.EcsContainerInstance:
    case IconTypes.Containers:
    case Resources.ContainerApp:
    case IconTypes.ContainersOnVirtualMachine:
    case IconTypes.ContainerService:
    case NativeResources.Container:
    case NativeResources.GcpContainer:
    case NativeResources.AzureContainerApp:
    case NativeResources.AzureContainer:
    case NativeResources.ElasticContainerService:
      return <ECSInstanceIcon />;

    /*case Categories.Cluster:
      return <ClusterIcon />;*/

    case CustomIconTypes.EventLog:
      return <EventLogIcon />;

    case IconTypes.CloudSlash:
      return <CloudSlashIcon />;

    case CustomIconTypes.CloudService:
    case IconTypes.CloudPosture:
      return <CloudServiceIcon />;

    case IconTypes.Actions:
      return <ActionsIcon />;

    case IconTypes.Action:
      return <ActionIcon />;

    case CustomIconTypes.Permission:
    case ContextType.ExcessPermissions:
    case CustomIconTypes.EXCESS_PERMISSIONS:
      return <PermissionsActionsIcon />;

    case NativeResources.SecurityGroup:
    case NativeResources.DatabaseSecurityGroup:
    case NativeResources.GcpCloudFirewall:
    case NativeResources.AzureSecurityGroups:
    case NativeResources.AzureApplicationSecurityGroups:
    case 'Access':
    case Resources.ComputeFirewall:
    case Resources.DatabaseFirewall:
    case 'DatabaseAccess':
      return <SecurityGroupIcon />;

    case CustomIconTypes.DatabaseSecurity:
      return <DatabaseSecurityIcon />;

    case Resources.Account:
    case NativeResources.AwsAccount:
    case NativeResources.GcpProject:
    case 'AccountSummary':
    case NativeResources.AzureSubscriptions:
    case NativeResources.GoogleWorkspaceAccount:
    case ReportTypes.AccountGovernance:
    case IconTypes.SnowflakeSubscription:
      return <AccountIcon />;

    case NativeResources.GcpServiceAccount:
      return <ServiceAccountIcon />;

    case NativeResources.AccountRoot:
      return <AccountRootIcon />;

    case NativeResources.GcpsqlInstances:
    case NativeResources.GcpsqlUsers:
      return <SqlDatabaseIcon />;

    case NativeResources.CloudTrail:
    case NativeResources.GcpCloudLogMetrics:
    case NativeResources.AzureLogProfile:
      return <CloudtrailIcon />;

    case Resources.ActionLog:
    case Resources.CloudServiceLog:
    case 'ActionLogs':
    case 'NetworkLogs':
    case Categories.Logging:
      return <ActionLogsIcon />;

    case NativeResources.CloudWatchLogGroup:
    case NativeResources.CloudWatchLogs:
    case NativeResources.CloudWatchAlarms:
    case NativeResources.CloudWatchMetrics:
    case NativeResources.CloudWatchMetricAlarms:
    case NativeResources.AzureLogAnalyticsWorkspace:
    case NativeResources.AzureMetricAlertRule:
      return <CloudWatchMonitoringIcon />;

    case NativeResources.GcpDialogflowCxAgent:
      return <CxAgentIcon />;

    case NativeResources.ElasticSearch:
    case Clients.Elasticsearch:
      return <ElasticsearchIcon />;

    case NativeResources.ElasticMapReduce:
    case NativeResources.GcpDataprocCluster:
      return <ElasticMapReduceIcon />;

    case Resources.Analytics:
    case NativeResources.GcpPubSub:
      return <AnalyticsIcon />;

    case CustomIconTypes.Internet:
      return <Image src={internet} w="full" h="full" />;

    case NativeResources.NatGateway:
    case NativeResources.GcpCloudNat:
    case NativeResources.AzureNatGateway:
      return <NatGatewayIcon />;

    case 'Gateway':
    case NativeResources.ApiGatewayDomain:
    case Resources.ApiGateway:
    case NativeResources.ApiGatewayRestApi:
    case NativeResources.GcpapiGateway:
    case NativeResources.AzureApiManagementService:
      return <APIGatewayApiIcon />;

    case Resources.NetworkGateway:
    case NativeResources.AzureVirtualNetworkGateway:
      return <APIGatewayIcon />;

    case NativeResources.VpnGateway:
    case NativeResources.GcpvpnGateway:
      return <VpnGatewayIcon />;

    case NativeResources.InternetGateway:
      return <InternetGatewayIcon />;

    case NativeResources.AzureVirtualWan:
      return <VirtualWANIcon />;

    case NativeResources.AzureDatabricksWorkspace:
      return <AzureDatabricksIcon />;

    case NativeResources.AzureSynapseWorkspace:
      return <AzureSynapseAnalyticsIcon />;

    case NativeResources.AutoscalingGroup:
    case Resources.AutoScaling:
      return <AutoScalingIcon />;

    case NativeResources.Ec2AutoScalingGroup:
    case NativeResources.GcpComputeEngineAutoscaler:
    case NativeResources.AzureVirtualMachineScaleSets:
      return <Ec2AutoScalingGroupIcon />;

    case CustomIconTypes.Chat:
      return <ChatIcon />;

    case Categories.Backup:
    case NativeResources.RdsSnapshot:
    case NativeResources.BackupPlan:
    case NativeResources.GcpFilestoreBackup:
    case NativeResources.AzureSnapshot:
    case CustomIconTypes.DATA_RECOVERY:
    case 'VMBackup':
    case 'RDSClusterSnapshot':
      return <BackupIcon />;

    case NativeResources.ElasticBlockStorage:
    case NativeResources.GcpPersistentDisk:
    case NativeResources.AzureManagedDisk:
    case Resources.BlockStorage:
      return <BlockStorageIcon />;

    case NativeResources.AcmCertificate:
    case NativeResources.GcpsqlsslCerts:
    case NativeResources.AzureCertificate:
    case Resources.Certificate:
      return <CertificateIcon />;

    case NativeResources.RdsCertificate:
      return <RdsCertificateIcon />;

    case NativeResources.AwsConfigRule:
    case NativeResources.AzureDiagnosticSetting:
    case Resources.Configuration:
      return <ConfigurationIcon />;

    case NativeResources.IamUserAccessKey:
    case NativeResources.AzureKeyVault:
    case 'AccessKey':
      return <AccessKeyIcon />;

    case Categories.Credential:
    case NativeResources.KeyManagementService:
    case NativeResources.GcpCloudKms:
    case NativeResources.AzureKeyVaultKeys:
    case Resources.Key:
    case ContextType.CredentialFound:
    case CustomIconTypes.INSECURE_CREDENTIALS:
    case CustomIconTypes.AUTH0_CREDENTIALS:
    case CustomIconTypes.AWS_ACCESS_KEY:
    case CustomIconTypes.AWS_SECRET_ID:
    case CustomIconTypes.AZURE_CREDENTIALS:
    case CustomIconTypes.CELERY_CREDENTIALS:
    case CustomIconTypes.CREDENTIALS:
    case CustomIconTypes.GCP_CREDENTIALS:
    case CustomIconTypes.OPEN_AI_KEYS:
    case CustomIconTypes.PRIVATE_CREDENTIALS:
    case CustomIconTypes.SECRETS:
    case CustomIconTypes.SENDGRID_CREDENTIALS:
    case CustomIconTypes.SSH_KEYS:
    case CustomIconTypes.STRIPE_CREDENTIALS:
    case CustomIconTypes.TWILIO_CREDENTIALS:
    case 'api-keys':
      return <KeyIcon />;

    case CustomIconTypes.CRYPTO:
    case CustomIconTypes.IBAN_CODE:
    case CustomIconTypes.US_BANK_NUMBER:
      return <PayIcon />;

    case CustomIconTypes.CREDIT_CARD:
      return <CreditCardIcon />;

    case Resources.Dns:
      return <DNSIcon />;

    case IconTypes.ThumbsUp:
      return <ThumbsUpIcon />;

    case IconTypes.ThumbsDown:
      return <ThumbsDownIcon />;

    case 'Route53':
    case NativeResources.Route53HealthCheck:
    case CustomIconTypes.Route53TrafficPolicy:
      return <Route53HealthCheckIcon />;

    case CustomIconTypes.Route53RecordSet:
      return <Route53RecordSetIcon />;

    case NativeResources.Route53HostedZone:
    case NativeResources.GcpCloudDnsZone:
    case NativeResources.GcpCloudDomainsRegistration:
    case NativeResources.AzureDnsZones:
    case NativeResources.AzurePrivateDnsZone:
    case CustomIconTypes.Route53SubDomain:
      return <Route53HostedZoneIcon />;

    case NativeResources.RdsCluster:
      return <RdsClusterIcon />;

    case CustomIconTypes.RdsInstance:
    case 'RDS':
      return <RdsInstanceIcon />;

    case NativeResources.NeptuneCluster:
      return <NeptuneClusterIcon />;

    case 'DatabaseCluster':
    case 'Cluster':
    case NativeResources.DocumentDbCluster:
      return <DocumentDbClusterIcon />;

    case Resources.DataCluster:
      return <ClusterIcon />;

    case Categories.Compute:
      return <ServerIcon />;

    case Categories.App:
    case NativeResources.AzureAdApplication:
    case NativeResources.OktaApplication:
    case NativeResources.EntraIdApplication:
    case Resources.Application:
    case Resources.AppManagement:
      return <AppIcon />;

    case CustomIconTypes.Technology:
    case VulnerabilityType.Application:
      return <TechnologyIcon />;

    case CustomIconTypes.Packages:
    case VulnerabilityType.Library:
      return <PackagesIcon />;

    case NativeResources.Neptune:
      return <NeptuneInstanceIcon />;

    case NativeResources.RelationalDatabaseService:
    case NativeResources.GcpCloudSql:
    case NativeResources.AzureSqlServer:
    case IconTypes['Relational Database Service (RDS)']:
      return <RdsIcon />;

    case IconTypes.DataGroup:
      return <DataGroupIcon />;

    case IconTypes.PolicyScroll:
      return <PolicyScrollIcon />;

    case 'DatabaseInstance':
    case Categories.Data:
    case Resources.Database:
    case IconTypes.DataRecovery:
    case IconTypes.DataSecurity:
    case NativeResources.SnowflakeDatabases:
    case NativeResources.GcpBigtableInstances:
    case NativeResources.AzureSqldbServersDatabase:
    case NativeResources.AzurePostgresSqlFlexibleServersDatabase:
    case IconTypes.AnomalousDataSources:
      return <DatabaseIcon />;

    case NativeResources.DocumentDb:
    case NativeResources.GcpFirestore:
      return <DocumentDBIcon />;

    case NativeResources.DynamoDb:
      return <DynamoDbIcon />;

    case CustomIconTypes.Distribution:
      return <DistributionIcon />;

    case CustomIconTypes.Environment:
      return <EnvironmentIcon />;

    case 'File':
    case Resources.FileStorage:
    case IconTypes.S3Folder:
    case NativeResources.ElasticFileSystem:
    case NativeResources.GcpFilestore:
    case NativeResources.AzureFileShare:
      return <FileIcon />;

    case 'Firewall':
    case NativeResources.WafRegional:
    case NativeResources.Wafv1:
    case NativeResources.Wafv2:
    case NativeResources.AzureFirewall:
    case Resources.AppFirewall:
      return <WAFIcon />;

    case NativeResources.WafRegionalWebAcl:
    case NativeResources.AzureFirewallPolicy:
    case NativeResources.AzureFrontDoorWafPolicy:
      return <WAFRulesIcon />;

    case NativeResources.AzureApplicationGatewayWafPolicy:
      return <FirewallAclRulesIcon />;

    case NativeResources.IamGroup:
    case Resources.Group:
    case IconTypes.IdentityAndAccess:
    case NativeResources.OktaGroup:
    case NativeResources.AzureAdGroup:
    case NativeResources.GitHubGroup:
    case NativeResources.GitLabGroup:
    case NativeResources.GcpGroup:
    case NativeResources.EntraIdGroup:
    case NativeResources.AzureManagementGroups:
    case NativeResources.GoogleWorkspaceGroup:
      return <GroupIcon />;

    case NativeResources.EntraIdServicePrincipal:
      return <EntraIdServicePrincipalIcon />;

    case NativeResources.ElasticNetworkInterface:
    case Resources.NetworkInterface:
    case NativeResources.VirtualInterface:
    case NativeResources.GcpNetworkInterface:
    case NativeResources.AzureNetworkInterface:
      return <NetworkInterfaceIcon />;

    case CustomIconTypes.Interface:
      return <InterfaceIcon />;

    case CustomIconTypes.Attach:
      return <AttachIcon />;

    case CustomIconTypes.Detach:
      return <DetachIcon />;

    case CustomIconTypes.Severity:
      return <SeverityIcon />;

    case 'Addon':
    case 'NodeGroup':
    case NativeResources.ElasticKubernetesService:
    case NativeResources.Gcpgke:
    case NativeResources.Aks:
    case IconTypes.CISEKS15:
    case IconTypes.Kubernetes:
    case 'CIS_EKS_1_5':
      return <KubernetesIcon />;

    case CustomIconTypes.ISO27001:
    case CustomIconTypes.ISO27001_2022:
    case CustomIconTypes.ISO27701_2019:
    case CustomIconTypes.ISO27701:
    case CustomIconTypes.ISO_27701:
      return <ISOIcon />;

    case 'ELB':
    case 'ELBConfiguration':
    case 'RDSDBParameterGroup':
    case NativeResources.ElasticLoadBalancer:
    case NativeResources.ElasticLoadBalancerv2:
    case NativeResources.GcpurlMaps:
    case NativeResources.AzureLoadBalancer:
    case NativeResources.AzureApplicationGateway:
    case NativeResources.GcpBackendBucket:
    case Resources.LoadBalancer:
      return <LoadBalancerIcon />;

    case Categories.Monitoring:
    case Resources.CloudMonitoring:
    case Resources.DnsMonitoring:
    case CustomIconTypes.DATA_AT_RISK:
    case CustomIconTypes.Informational:
    case NativeResources.GcpCloudMonitoringChannel:
    case NativeResources.AzureApplicationInsights:
      return <MonitoringIcon />;

    case Categories.Network:
    case IconTypes.Networking:
    case NativeResources.NetworkAcl:
    case NativeResources.AzureNetworkWatcher:
    case Resources.AccessControl:
    case ReportTypes.NetworkAssessment:
      return <NetworkACLIcon />;

    case NativeResources.AwsVirtualPrivateNetwork:
      return <VpnIcon />;

    case NativeResources.SystemsManagerDocument:
    case Resources.AgentConfiguration:
      return <SSMDocumentIcon />;

    case CustomIconTypes.Hide:
      return <HideIcon />;

    case CustomIconTypes.Mask:
      return <MaskIcon />;

    case IconTypes.NetworkMap:
      return <NetworkMapIcon />;

    case CustomIconTypes.Ubuntu:
      return <UbuntuIcon />;

    case CustomIconTypes.Windows:
    case CustomIconTypes.windows11:
      return <WindowsIcon />;

    case NativeResources.SimpleNotificationService:
    case NativeResources.GcpPubSubLite:
    case NativeResources.AzureServiceBusNamespace:
    case CustomIconTypes.SNSSubscription:
    case CustomIconTypes.SNSTopic:
      return <SnsNotificationIcon />;

    case 'SNS':
    case NativeResources.RdsEventSubscription:
      return <NotificationIcon />;

    case CustomIconTypes.Notification:
      return <NotifyIcon />;

    case 'S3':
    case 'S3Object':
    case NativeResources.SimpleStorageService:
    case NativeResources.GcpBucket:
    case NativeResources.AzureBlobStorage:
    case NativeResources.AzureStorageAccount:
    case NativeResources.S3VectorBucket:
    case NativeResources.S3TableBucket:
    case Resources.ObjectStorage:
    case IconTypes['SimpleStorageService(S3)']:
      return <ObjectStorageIcon />;

    case 'OrgUnit':
    case NativeResources.OrganizationUnit:
    case NativeResources.GcpFolder:
    case NativeResources.EntraIdDomain:
    case NativeResources.GoogleWorkspaceOrgUnit:
    case Resources.OrganizationUnits:
      return <OrganizationUnitIcon />;

    case NativeResources.AwsOrganization:
    case Categories.Organization:
    case Resources.Organizations:
    case NativeResources.OktaOrganization:
    case NativeResources.AzureAdOrganization:
    case NativeResources.GcpOrganization:
    case NativeResources.EntraId:
      return <OrganizationIcon />;

    case NativeResources.GcpForwardingRules:
      return <ForwardingRuleIcon />;

    case NativeResources.TransitGatewayConnect:
    case NativeResources.VpcPeeringConnection:
    case NativeResources.AzureVirtualNetworkPeering:
    case Resources.P2P:
      return <P2PIcon />;

    case Categories.Policy:
    case Resources.PermissionsPolicy:
    case NativeResources.OktaPolicy:
    case NativeResources.AzurePolicyAssignment:
    case NativeResources.AzurePolicyDefinition:
    case NativeResources.AzurePolicySetDefinition:
    case NativeResources.EntraIdConditionalAccessPolicy:
    case NativeResources.GcpapiGatewayConfigurations:
    case NativeResources.GoogleWorkspacePolicy:
    case CustomIconTypes.Blueprint:
      return <PolicyIcon />;

    case NativeResources.ResourcePolicy:
    case NativeResources.GcpResourcePolicy:
    case NativeResources.AsgResourcePolicy:
      return <PolicyResourceIcon />;

    case NativeResources.IamPolicy:
    case NativeResources.IamInlinePolicy:
      return <PolicyUserIcon />;

    case NativeResources.GcpiamPolicy:
      return <IamPolicyIcon />;

    case NativeResources.AzureRoleDefinition:
      return <RoleDefinitionIcon />;

    case NativeResources.AzureRoleAssignment:
      return <PolicyRoleIcon />;

    case NativeResources.AccountPasswordIdentityPolicy:
      return <PolicyPasswordIcon />;

    case NativeResources.OrganizationPolicy:
    case NativeResources.GcpOrgPolicyService:
      return <PolicyOrganizationIcon />;

    case NativeResources.AwsqBusiness:
      return <AWSQIcon />;

    case NativeResources.SimpleQueueService:
    case NativeResources.GcpCloudTasksQueue:
    case NativeResources.AzureStorageQueue:
    case Resources.AppMessaging:
    case IconTypes.Queue:
      return <QueueIcon />;

    case IconTypes.ScanningQueue:
      return <ScanningQueueIcon />;

    case CustomIconTypes.Region:
      return <RegionIcon />;

    case CustomIconTypes.Rules:
      return <RulesIcon />;

    case Resources.Role:
    case Resources.SamlRole:
    case Resources.DirectoryRole:
    case NativeResources.IamRole:
    case NativeResources.SnowflakeRoles:
    case NativeResources.GcpRole:
    case NativeResources.EntraIdDirectoryRole:
    case NativeResources.GoogleWorkspaceRole:
    case ReportTypes.RoleAccessReview:
      return <RoleIcon />;

    case NativeResources.SubnetRouteTable:
    case NativeResources.TransitGatewayRouteTable:
    case NativeResources.AzureRouteTable:
    case Resources.RouteTable:
      return <RouteTableIcon />;

    case CustomIconTypes.VpcGateway:
      return <VpcGatewayIcon />;

    case CustomIconTypes.Route:
    case NativeResources.GcpRoute:
      return <RouteIcon />;

    case 'Serverless':
    case NativeResources.LambdaFunction:
    case NativeResources.GcpCloudFunctions:
    case NativeResources.AzureFunctions:
    case Resources.ServerlessCompute:
      return <ServerlessIcon />;

    case Categories.Code:
    case 'AutoscalingLaunchConfiguration':
    case IconTypes.Repository:
    case NativeResources.CloudFormation:
    case NativeResources.GcpCloudDeploymentManager:
    case NativeResources.GitHubRepository:
    case NativeResources.BitBucketRepository:
    case NativeResources.AzureArmTemplate:
    case SupportedServices.GitLabBranch:
    case SupportedServices.GitHubBranch:
    case SupportedServices.BitBucketBranch:
    case Resources.InfrastructureasCode:
    case CloudEnvironmentType.Iac:
      return <CloudFormationIcon />;

    case NativeResources.Ec2LaunchTemplate:
      return <Ec2LaunchTemplateIcon />;

    case NativeResources.AzureBastionHost:
      return <BastionHostIcon />;

    case NativeResources.AzureComputeFleet:
      return <ComputeFleetIcon />;

    case Resources.Subnets:
    case NativeResources.Subnet:
    case NativeResources.GcpSubnetwork:
    case NativeResources.AzureVirtualNetworkSubnets:
    case CustomIconTypes.PublicSubnets:
      return <SubnetIcon />;

    case NativeResources.VirtualPrivateCloud:
    case NativeResources.GcpVirtualPrivateCloud:
    case NativeResources.AzureVirtualNetworkTaps:
    case NativeResources.AzureVirtualNetwork:
    case Resources.Vpc:
      return <SuperNetIcon />;

    case Categories.Identity:
    case NativeResources.IamUser:
    case Resources.User:
    case CustomIconTypes.IdentityAndAccessManagement:
    case NativeResources.OktaUser:
    case NativeResources.SnowflakeUsers:
    case NativeResources.AzureAdUser:
    case NativeResources.GitHubUser:
    case NativeResources.GitLabUser:
    case NativeResources.GcpUser:
    case NativeResources.IdentityCentreInstance:
    case NativeResources.EntraIdUser:
    case NativeResources.GoogleWorkspaceUser:
    case ReportTypes.UserAccessReview:
    case CustomIconTypes.PERSON:
    case CustomIconTypes.NRP:
    case CustomIconTypes.IN_AADHAR:
    case CustomIconTypes.IN_PAN:
    case CustomIconTypes.US_DRIVER_LICENSE:
    case CustomIconTypes.US_ITIN:
    case CustomIconTypes.US_PASSPORT:
    case CustomIconTypes.US_SSN:
      return <UserIcon />;

    case ReportTypes.Compliance:
      return <ComplianceIcon />;

    case CustomIconTypes.IdentityAuthorization:
      return <UserIcon />;
    //return <IdentityAuthorizationIcon bg={bgColor ?? '#fff'} />;

    case ReportTypes.Inventory:
      return <InventoryIcon />;

    case NativeResources.Ec2Instance:
    case Resources.VirtualMachine:
    case IconTypes.VirtualMachines:
    case 'VirtualMachines':
    case 'Virtual Machine':
    case NativeResources.GcpComputeEngine:
    case NativeResources.GcpCloudTpus:
    case NativeResources.AzureVirtualMachine:
    case NativeResources.AzureVirtualMachineScaleSetInstance:
      return <VirtualMachineIcon />;

    case 'Warehouse':
    case CustomIconTypes.AriksaOutpost:
    case NativeResources.RedshiftCluster:
    case CustomIconTypes.RedshiftInstance:
    case NativeResources.GcpBigQuery:
      return <RedshiftIcon />;

    case NativeResources.EbsSnapshot:
    case NativeResources.GcpMachineImage:
    case Resources.Snapshot:
    case IconTypes.DataSources:
    case IconTypes.Saas:
      return <SnapshotIcon />;

    case 'NetworkAttachment':
    case 'TransitGatewayVPCAttachment':
    case Resources.VpcTransitRoute:
    case NativeResources.TransitGateway:
    case NativeResources.TransitGatewayAttachment:
      return <TransitGatewayAttachmentIcon />;

    case CloudProviders.Okta:
    case CloudProvider.Okta:
    case CustomIconTypes.Okta:
    case NativeResources.OktaDomain:
    case NativeResources.OktaRoleSubscription:
    case NativeResources.OktaIdentityProvider:
      return <OktaIcon />;

    case CloudProviders.Aws:
    case CloudProvider.Aws:
    case ComplianceStandards.CisAws14:
    case ComplianceStandards.CisAws15:
    case IconTypes.CISAWS14:
    case IconTypes.CISAWS15:
    case CustomIconTypes.AWS:
      return <AwsIcon />;

    case CustomIconTypes.AWSWhite:
      return <AwsIcon color="inherit" />;

    case IdentityProviderName.Microsoft:
      return <AzureEntraIDIcon />;

    case IconTypes.AzureEntraConnect:
      return <AzureEntraConnectIcon />;

    case CloudProviders.Azure:
    case CloudProvider.Azure:
    case 'Azure':
    case 'CIS AZURE 3.0.0':
    case ComplianceStandards.CisAzureV300:
    case ComplianceStandards.MicrosoftAzureFoundationsBenchmarkV600:
      return <AzureIcon />;

    case CustomIconTypes.Vmware:
      return <VmwareIcon />;

    case CloudProviders.Gcp:
    case CloudProvider.Gcp:
    case IconTypes.CISGCPv3:
    case IconTypes.CISGCPv4:
      return <GoogleCloudIcon />;

    case CustomIconTypes.NoSql:
      return <NoSqlIcon />;

    case CustomIconTypes.AlpineLinux:
      return <AlpineLinuxIcon />;

    case ApplicationEnum.MySql:
      return <MysqlIcon />;

    case NativeResources.AwsmySql:
    case NativeResources.AzureMysqlFlexibleServer:
    case NativeResources.AzureMysqlFlexibleServerDatabase:
      return <CloudMysqlIcon />;

    case ApplicationEnum.Nginx:
      return <NginxIcon />;

    case ApplicationEnum.HaProxy:
      return <HAProxyIcon />;

    case ApplicationEnum.Neo4j:
      return <Neo4jIcon />;

    case ApplicationEnum.ApacheHttp:
      return <ApacheHttpIcon />;

    case ApplicationEnum.Cassandra:
      return <ApacheCassandraIcon />;

    case NativeResources.AzureCosmosCassandraCluster:
      return <CassandraIcon />;

    case NativeResources.AzureCosmosDatabaseAccount:
      return <AzureCosmosDbIcon />;

    case NativeResources.AzureDataExplorerClusters:
    case NativeResources.AzureDataExplorerClustersDatabases:
      return <AzureDataExplorerIcon />;

    case NativeResources.AzureEventHubsNamespace:
      return <AzureEventHubsIcon />;

    case ApplicationEnum.Kafka:
      return <ApacheKafkaIcon />;

    case ApplicationEnum.Redis:
      return <RedisIcon />;

    case ApplicationEnum.RabbitMq:
      return <RabbitMQIcon />;

    case NativeResources.AzurePostgreSqlFlexibleServer:
    case ApplicationEnum.PostgreSql:
      return <PostgreSQLIcon />;

    case ApplicationEnum.Memcached:
      return <MemCachedIcon />;

    case ApplicationEnum.MariaDb:
      return <MariaDBIcon />;

    case ApplicationEnum.MongoDb:
      return <MongoDBIcon />;

    case ApplicationEnum.CouchDb:
      return <CouchDBIcon />;

    case ScanTypes.NpmPackages:
    case VulnerabilityType.Os:
    case CustomIconTypes.OperatingSystem:
      return <OperatingSystemIcon />;

    case 'npm':
      return <NpmIcon />;

    case 'rpm':
      return <RpmIcon />;

    case CustomIconTypes.AmazonLinux:
      return <AmazonLinuxIcon />;

    case CustomIconTypes.DebianLinux:
    case CustomIconTypes.Debian:
    case CustomIconTypes.debian:
    case 'deb':
      return <DebianIcon />;

    case CustomIconTypes.Library:
      return <LibraryIcon />;

    case CustomIconTypes.Python:
    case LibraryType.Python:
      return <PythonIcon />;

    case LibraryType.Ruby:
      return <RubyIcon />;

    case LibraryType.Golang:
      return <GolangIcon />;

    case LibraryType.Nodejs:
      return <NodeJSIcon />;

    case LibraryType.Java:
      return <JavaIcon />;

    case NativeResources.ElastiCache:
    case NativeResources.GcpMemorystoreRedis:
    case NativeResources.AzureRedis:
      return <ElasticacheIcon />;

    case Resources.Cache:
      return <CacheIcon />;

    case NativeResources.ElastiCacheReplicationGroup:
      return <ElastiCacheReplicationGroupIcon />;

    case NativeResources.CloudFront:
    case NativeResources.AzureFrontDoor:
    case NativeResources.GcpMediaCdnEdgeCacheOrigin:
    case Resources.ContentDeliveryNetwork:
      return <DistributionCloudfrontIcon />;

    case CustomIconTypes.ExclamationTriangle:
    case ReportTypes.Issues:
      return <ExclamationTriangleIcon />;

    case CustomIconTypes.ExclamationCircle:
      return <ExclamationCircleIcon />;

    case IconTypes.Cve:
      return <CveIcon />;

    case CustomIconTypes.SuppressAlarm:
      return <SuppressAlarmIcon />;

    case CustomIconTypes.Suppress:
      return <SuppressIcon />;

    case CustomIconTypes.Exclude:
      return <ExcludeIcon />;

    case CustomIconTypes.BlueprintView:
      return <BlueprintViewIcon />;

    case CustomIconTypes.Egress:
      return <EgressIcon />;

    case CustomIconTypes.Ingress:
      return <IngressIcon />;

    case NativeResources.SystemsManager:
    case Resources.Agent:
      return <AgentIcon />;

    case NativeResources.AzureAdDomain:
      return <AzureADDomainIcon />;

    case NativeResources.AzureAdsamlRole:
    case NativeResources.AzureAdDirectoryRoles:
      return <AzureADRoleIcon />;

    case NativeResources.ElasticIp:
    case NativeResources.AzurePublicIpAddresses:
    case NativeResources.AzureIpGroup:
    case Resources.Ip:
      return <ElasticIPIcon />;

    case NativeResources.ElasticBeanstalk:
      return <ApplicationOrchestrationElasticBeanstalkIcon />;

    case NativeResources.Secret:
    case NativeResources.AzureSecrets:
    case NativeResources.GcpSecretManager:
    case Resources.Secrets:
      return <SecretsPasswordIcon />;

    case NativeResources.SshKeyPair:
      return <SSHKeyPairIcon />;

    case CustomIconTypes.Alert:
    case NativeResources.AzureSecurityAlert:
      return <BellIcon />;

    case CustomIconTypes.DataScan:
      return <DataScanIcon />;

    case CustomIconTypes.Vulnerability:
    case CustomIconTypes.VULNERABILITIES:
    case CustomIconTypes.Vulnerabilities:
    case ContextType.CriticalVulnerability:
    case ContextType.HighVulnerability:
    case ContextType.CriticalHighVulnerability:
    case ReportTypes.VulnerabilitiesSummary:
    case ReportTypes.VulnerabilitiesDetailed:
      return <VulnerabilityIcon />;

    case CustomIconTypes.TrustedEntities:
      return <TrustedEntitiesIcon />;

    case IconTypes.Slack:
    case Clients.Slack:
      return <SlackIcon />;

    case IconTypes.Jira:
    case Clients.Jira:
      return <JiraIcon />;

    case IconTypes.Servicenow:
      return <ServiceNowIcon />;

    case IconTypes.Email:
    case CustomIconTypes.ARIKSA_EMAIL:
    case CustomIconTypes.GMAIL_EMAIL:
    case CustomIconTypes.EMAIL_ADDRESS:
      return <MailIcon />;

    case IconTypes.Teams:
      return <MicrosoftTeamsIcon />;

    case IconTypes.Clock:
    case IconTypes.Jit:
      return <ClockIcon />;

    case IconTypes.IndividualAlerts:
      return <IndividualAlertsIcon />;

    case IconTypes.Label:
    case IconTypes.Tag:
      return <TagIcon />;

    case IconTypes.SIEM:
      return <SIEMIcon />;

    case IconTypes.Access:
      return <AccessIcon />;

    case IconTypes.CloudActivity:
      return <ActivityIcon />;

    case IconTypes.Hacker:
    case IconTypes['Malicious Access']:
    case IconTypes['Malicious Behavior']:
    case IconTypes['Malicious']:
    case V1CloudEventsInsightCategory.Malicious:
      return <HackerIcon />;

    case IconTypes.QuestionMark:
      return <BsQuestionCircle />;

    case IconTypes.Context:
      return <ContextIcon />;

    case IconTypes.ContextLabel:
      return <ContextLabelIcon />;

    case IconTypes.Console:
      return <ConsoleIcon />;

    case IconTypes.Whitelist:
    case IconTypes.CheckmarkCircle:
      return <CheckmarkCircleOutlineIcon />;

    case IconTypes.CloseCircle:
      return <CloseCircleOutlineIcon />;

    case IconTypes.Metadata:
      return <MetadataIcon />;

    case IconTypes.Exception:
      return <ExceptionIcon />;

    case IconTypes.PolicyResourceException:
      return <PolicyExceptionResourceIcon />;

    case IconTypes.Checklist:
      return <ChecklistIcon />;

    case IconTypes.Dependencies:
      return <DependenciesIcon />;

    case IconTypes.BarChart:
      return <BarChartIcon />;

    case IconTypes.Sms:
    case Clients.Sns:
    case CustomIconTypes.PHONE_NUMBER:
      return <SMSIcon />;

    case IconTypes.Ticket:
      return <TicketIcon />;

    case IconTypes.Sso:
      return <SSOIcon />;

    case IconTypes.AzureActiveDirectory:
    case IconTypes.azuread:
    case CloudProviders.AzureAd:
    case CloudProvider.AzureAd:
      return <AzureActiveDirectoryIcon />;

    case CloudProviders.Snowflake:
    case CloudProvider.Snowflake:
    case CustomIconTypes.Snowflake:
    case NativeResources.SnowflakeSchemas:
    case NativeResources.SnowflakePrivileges:
      return <SnowflakeIcon />;

    case NativeResources.VertexAiEndpoint:
      return <AIEndpointIcon />;

    case Resources.AiDataset:
    case NativeResources.GcpVertexAiDataset:
      return <AIDatasetIcon />;

    case NativeResources.AzureDataFactory:
      return <AzureDataFactoryIcon />;

    case NativeResources.AzureDevOpsProject:
      return <AzureDevOpsProjectIcon />;

    case Resources.AiModel:
    case NativeResources.VertexAiModel:
      return <AIModelIcon />;

    case Resources.AiIndex:
    case NativeResources.VertexAiIndex:
    case NativeResources.GcpAgentBuilderDataStore:
      return <AIIndexIcon />;

    case NativeResources.GcpAgentBuilderEngine:
      return <AgentBuilderIcon />;

    case NativeResources.VertexAiTrainingPipeline:
      return <AIPipelineIcon />;

    case NativeResources.AzureOpenAiDeployment:
      return <AIDeploymentIcon />;

    case NativeResources.GcpDocumentAiProcessor:
      return <AIDocumentProcessorIcon />;

    case 'tableau':
      return <AnalyticsIcon />;

    case IconTypes.Search:
      return <SearchIcon />;

    case IconTypes.Remediate:
      return <RemediateIcon />;

    case IconTypes.Details:
      return <ShowIcon />;

    case IconTypes.Timeline:
      return <TimelineIcon />;

    case IconTypes.Disable:
      return <DisableIcon />;

    case IconTypes.ContainerVolume:
      return <ContainerVolumeIcon />;

    case IconTypes.DataClassification:
      return <DataClassificationIcon />;

    case ComplianceStandards.Nist80053:
    case ComplianceStandards.Nist80053Rev5:
    case 'NIST-800-53 Rev 5':
      return <NISTIcon pt={2} />;

    case ComplianceStandards.PciDssV321:
    case ComplianceStandards.PciDssV401:
    case 'PCI-DSS v3.2.1':
    case 'PCI DSS 4.0.1':
      return <PciIcon pt={1} />;

    case ComplianceStandards.CisV8:
    case IconTypes.CISv8:
      return <CISIcon />;

    case ComplianceStandards.Soc2:
    case IconTypes.SOC2:
      return <Soc2Icon />;

    case CustomIconTypes.AriksaLogo:
      return <CompanyLogoIcon />;

    case CustomIconTypes.AriksaLogoOnly:
    case CustomIconTypes.AriksaBestPractices:
      return <AriksaLogoOnlyIcon bg={bgColor ?? '#fff'} />;

    case CustomIconTypes.CloudChart:
      return <CloudChartIcon />;

    case CustomIconTypes.RegexDataClassifier:
      return <RegexDataClassifierIcon />;

    case CustomIconTypes.ComplianceResource:
      return <ComplianceResourceIcon />;

    case CustomIconTypes.ComplianceEnforcedChecks:
    case CustomIconTypes.EnforcedPolicies:
      return <ComplianceEnforcedChecksIcon />;

    case CustomIconTypes.ComplianceCheckExceptions:
      return <ComplianceCheckExceptionIcon />;

    case CustomIconTypes.ComplianceFailedChecks:
      return <ComplianceCheckFailedIcon />;

    case CustomIconTypes.CompliancePassedChecks:
      return <ComplianceCheckPassedIcon />;

    case CustomIconTypes.HistoricalTimeline:
      return <HistoricalTimelineIcon />;

    case CustomIconTypes.Home:
    case CustomIconTypes.ADDRESS:
      return <HomeIcon />;

    case CustomIconTypes.Automation:
      return <AutomationIcon />;

    case CustomIconTypes.List:
      return <ListIcon />;

    case CustomIconTypes.Overview:
      return <OverviewIcon />;

    case CustomIconTypes.Summary:
      return <SummaryIcon />;

    case CustomIconTypes.UserCanAccess:
      return <UserCanAccessIcon />;

    case ContextType.InternetAccessWide:
    case ContextType.InternetAccess:
    case ContextType.InternetAccessLimited:
      return <InternetAccessIcon />;

    case ContextType.BruteForceAttack:
      return <BruteForceIcon />;

    case ContextType.UnencryptedDisk:
    case ContextType.Unencrypted:
      return <UnencryptedDiskIcon />;

    case ContextType.CrossAccount:
    case 'CrossAccount':
      return <CrossAccountIcon />;

    case ContextType.MaliciousIngress:
      return <MaliciousIngressIcon />;

    case ContextType.SensitiveData:
    case CustomIconTypes.DataTypes:
      return <CriticalDataIcon />;

    case ContextType.Privileged:
    case CustomIconTypes.PRIVILEGE_ESCALATION:
      return <HighPrivilegesIcon />;

    /*case ContextType.MaliciousEgress:
      return <MaliciousEgressIcon />;
     */
    case CustomIconTypes.LineChart:
      return <LineChartIcon />;

    case CustomIconTypes.BurgerMenu:
      return <BurgerMenuIcon />;

    case CustomIconTypes.DataCloud:
      return <DataCloudIcon />;

    case CustomIconTypes.IdentityCloud:
    case CloudEnvironmentType.IdentityProvider:
      return <IdentityCloudIcon />;

    case NativeResources.GcpCloudIdentity:
      //case NativeResources.IdentityStoreUser:
      return <CloudIdentityIcon />;

    case CustomIconTypes.Snooze:
      return <SnoozeIcon />;

    //case NativeResources.GitlabAccount:
    case CloudProviders.Gitlab:
    case CloudProvider.GitLab:
    case CustomIconTypes.GitLab:
    case CloudProviders.GitlabIac:
      return <GitLabIcon />;

    //case NativeResources.GitHubAccount:
    case CloudProviders.Github:
    case CloudProvider.GitHub:
    case CustomIconTypes.GitHub:
    case CloudProviders.GithubIac:
      return <GithubIcon />;

    //case NativeResources.BitBucketAccount:
    case CloudProviders.Bitbucket:
    case CloudProvider.Bitbucket:
    case CustomIconTypes.BitBucket:
    case CloudProviders.BitbucketIac:
      return <BitbucketIcon />;

    //case NativeResources.GitLabBranch:
    //case NativeResources.BitBucketBranch:
    //case NativeResources.GitHubBranch:
    case IconTypes.RepoBranch:
      return <RepoBranchIcon />;

    //case NativeResources.GitHubProject:
    case NativeResources.GitLabProject:
      return <RepoProjectIcon />;

    case IconTypes.BucketDeny:
      return <BucketDenyIcon />;

    case IconTypes.Copy:
      return <CopyIcon />;

    case IconTypes.Cloud:
    case CloudEnvironmentType.CloudProvider:
      return <CloudIcon />;

    case CustomIconTypes.PolicyException:
      return <PolicyExceptionIcon />;

    case CustomIconTypes.DATA_ENCRYPTION:
    case CustomIconTypes.LockOpen:
      return <LockOpenIcon />;

    case CustomIconTypes.INTERNET_EXPOSURE:
    case CustomIconTypes.Globe:
    case CustomIconTypes.PublicVMsWithSSHOpen:
    case IconTypes.ExternallyAccessibleCompute:
      return <GlobeIcon />;

    case CustomIconTypes.NETWORK_MISCONFIGURATION:
      return <NetworkMisconfigurationIcon />;

    case CustomIconTypes.POOR_GOVERNANCE:
      return <ThumbsDownIcon />;

    case CustomIconTypes.DoubleTap:
      return <DoubleTapIcon />;

    case CustomIconTypes.POOR_AUDITABILITY:
      return <ActivityIcon />;

    case CustomIconTypes.UNUSED_ENTITIES:
    case IconTypes.Stopped:
      return <SyncPauseIcon />;

    case CustomIconTypes.ANOMALOUS_ACTIVITY:
      return <ZigzagIcon />;

    case CustomIconTypes.OutpostForVulnerability:
      return <OutpostForVulnerabilityIcon bg={bgColor ?? '#fff'} />;

    case CustomIconTypes.Comment:
      return <CommentIcon />;

    case CustomIconTypes.SuddenActivity:
      return <SuddenActivityIcon />;

    case CustomIconTypes.ThirdParty:
      return <ThirdPartyIcon />;

    case CustomIconTypes.NewFinding:
      return <NewFindingIcon />;

    case CustomIconTypes.AnomalousBehaviour:
    case CustomIconTypes['Abnormal Behavior']:
    case 'Anomalous Behavior':
    case V1CloudEventsInsightCategory.Anomalous:
      return <AnomalousBehaviourIcon />;

    case CustomIconTypes.Health:
    case CustomIconTypes.INSURANCE_INFORMATION:
    case CustomIconTypes.MEDICAL_LICENSE:
    case CustomIconTypes.UK_NHS:
      return <HealthIcon />;

    case CustomIconTypes.Port:
    case CustomIconTypes.IP_ADDRESS:
      return <NetworkPortIcon />;

    case CustomIconTypes.Printer:
      return <PrinterIcon />;

    case CustomIconTypes.GraphIncrease:
    case CustomIconTypes['Elevated Risk']:
      return <GraphIncreaseIcon />;

    case CustomIconTypes.GraphDecrease:
      return <GraphDecreaseIcon />;

    case CustomIconTypes.VMImages:
    case CustomIconTypes.ContainerImages:
      return <VMImageIcon />;

    case CustomIconTypes.MachineImage:
      return <MachineImageIcon />;

    case CustomIconTypes.Share:
      return <ShareIcon />;

    case CustomIconTypes.ThirdPartyIntegration:
      return <ThirdPartyIntegrationIcon />;

    case CustomIconTypes.ListOfInstances:
      return <ListOfInstancesIcon />;

    case CustomIconTypes.SyncRestart:
    case IconTypes.Running:
      return <SyncRestartIcon />;

    case CustomIconTypes.SyncPause:
      return <SyncPauseIcon />;

    case CustomIconTypes.EOL:
      return <EOLIcon />;

    case CustomIconTypes.RedHatEnterpriseLinux:
    case CustomIconTypes.RedHat:
      return <RedHatIcon />;

    case CustomIconTypes.Centos:
      return <CentosIcon />;

    case CustomIconTypes.ContainerRepository:
      return <ContainerRepositoryIcon />;

    case CustomIconTypes.LearnMore:
      return <LearnMoreIcon />;

    case CustomIconTypes.GoogleDrive:
      return <GoogleDriveIcon />;

    case CustomIconTypes.Google:
    case 'Google Workspace Foundations Benchmark v1.4.0':
    case CloudProvider.GoogleWorkspace:
    case CloudProviders.GoogleWorkspace:
      // Map the benchmark label to the branded Google icon.
      return <GoogleIcon />;

    case CustomIconTypes.MicrosoftOneDrive:
      return <MicrosoftOneDriveIcon />;

    case CustomIconTypes.Box:
      return <BoxIcon />;

    case CustomIconTypes.Dropbox:
      return <DropboxIcon />;

    case CustomIconTypes.ServiceTicket:
      return <ServiceTicketIcon />;

    case CustomIconTypes.Documents:
      return <DocumentsIcon />;

    case CustomIconTypes.PublicIPs:
      return <ElasticIPIcon />;

    case CustomIconTypes.AnomalousTraffic:
      return <HackerIcon />;

    case CustomIconTypes.ExposedCredentials:
      return <LeakedCredentialIcon />;

    case CustomIconTypes.VMsWithSSHOpen:
      return <LoginIcon p={0.5} />;

    case CustomIconTypes.Patch:
      return <PatchIcon />;

    case CustomIconTypes.Play:
      return <PlayIcon />;

    case CustomIconTypes.Pause:
      return <PauseIcon />;

    case CustomIconTypes.Infinity:
      return <InfinityIcon />;

    case 'service':
      return <ServicesIcon />;

    default: {
      const item = lowerCase(type as string);
      const normalizedItem = item.replace(/[^a-z]/g, '');
      if (normalizedItem === 'githubaction') return <GithubIcon />;
      if (normalizedItem === 'npm') return <NpmIcon />;
      if (normalizedItem === 'gomodule') return <GolangIcon />;
      if (normalizedItem === 'javaarchive') return <JavaIcon />;
      if (includes(item, 'windows')) return <WindowsIcon />;
      if (includes(item, 'ubuntu')) return <UbuntuIcon />;
      if (item === 'deb' || includes(item, 'debian')) return <DebianIcon />;
      if (includes(item, 'rpm')) return <RpmIcon />;
      if (includes(item, 'centos')) return <CentosIcon />;
      if (includes(item, 'alpine')) return <AlpineLinuxIcon />;
      if (normalizedItem === 'operatingsystem') return <OperatingSystemIcon />;
      if (normalizedItem === 'apachetomcat') return <ApacheTomcatIcon />;
      return defaultIcon ?? <ServicesIcon />;
    }
  }
};
